const doc = [({"en":({"js":({"merfoto":({"albums":({"index":({"no_accessible_albums_were_found":"No accessible albums were found."})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;